
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/builders",
      function () {
        return require("private-next-pages/partners/builders.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/builders"])
      });
    }
  